import React from 'react'
import ReactLoading from "react-loading";
function HomeLoader() {
  return (
    // <div style={{background:"rgba(0,0,0,0.5)"}} >
    <div className='homeLoader' >
       <ReactLoading
        className="ldd"
        type="bubbles"
        color="white"
        height={"35%"}
        width={"35%"}
        /> 
    </div>
  )
}

export default HomeLoader